import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "./data";

const EASE = [0.16, 1, 0.3, 1];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="max-w-2xl mb-16"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-clay font-semibold mb-6">
            Client Stories
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-snug text-ink">
            Trusted by the people
            <span className="italic text-clay"> who matter most.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.author}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
              className={`bg-[#F5F0E8] border border-[#E5DDD0] rounded-3xl p-8 lg:p-10 flex flex-col hover:-translate-y-1 hover:shadow-[0_30px_60px_-35px_rgba(44,38,35,0.4)] transition-all duration-500 ${
                i === 1 ? "md:-translate-y-6" : ""
              }`}
            >
              <Quote size={28} className="text-clay/40 mb-6" />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={14} className="fill-gold text-gold" />
                ))}
              </div>
              <blockquote className="font-serif text-xl font-normal italic leading-relaxed text-ink flex-1">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-[#E5DDD0]">
                <p className="text-sm font-semibold text-ink">{t.author}</p>
                <p className="text-xs text-clay mt-1">{t.treatment}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
